import React from 'react';
import I18nSettingsContainer from '../containers/i18n_settings_container';

const I18nContext = React.createContext(new I18nSettingsContainer());

export default I18nContext;
